/*
     s1 - Keyboard Navigation // todo note, removed
     s2 - Cursor
     s3 - Contrast
     s10 - Reading Guide
     s4 - Bigger Text
     s6 - Highlight links
     s7 - Legible fonts
     s9 - Reader
     s11 - Page structure
     s12 - Tooltips
     s13 - Stop Animations
     s14 - Text Spacing
     s15 - Dyslexia Font
     s16 - Reading Mask
     s17 - Line height
     s18 - Smart Contrast
     s19 - Text Align
     s21 - Inline Dictionary
     s22 - Booked for skipLinks usage stat
     s23 - Saturation
     s24 - Voice Navigation
    */

export const ALLY_FEATURES = {
  /* 's1': {
        description: 'Keyboard Navigation',
        modifyMenuLabel: 'Keyboard Nav',
        actionStates: {
            0: {
                'iconClass': 'keyboard-nav',
                'iconAlt': 'widget.menu.keyboard_nav.alt',
                'label': 'widget.menu.keyboard_nav.label',
                'aria': 'widget.menu.keyboard_nav.aria'
            },
            1: {
                'iconClass': 'keyboard-nav',
                'iconAlt': 'widget.menu.keyboard_nav.alt',
                'label': 'widget.menu.keyboard_nav.label',
                'aria': 'widget.menu.keyboard_nav.aria_on_action'
            }
        },
        onActionTrigger: function (actionState) {
            let trigger: Record<string, string | number> = {feature: 's1'};
            if (actionState === 0 || !actionState) {
                trigger.actionState = 1;
                trigger.toRead = 'widget.menu.keyboard_nav.aria_on_action'
            } else {
                trigger.actionState = 0;
                trigger.toRead = 'widget.menu.keyboard_nav.aria_off_action'
            }
            return trigger;
        }
    }, */

  s2: {
    description: 'Cursor / Reading Guide',
    modifyMenuLabel: 'Big Cursor',
    actionStates: {
      0: {
        iconClass: 'cursor',
        iconAlt: '',
        label: 'widget.menu.cursor.label',
        aria: 'widget.menu.cursor.aria',
      },
      1: {
        iconClass: 'cursor',
        iconAlt: '',
        label: 'widget.menu.big_cursor.label',
        aria: 'widget.menu.big_cursor.aria',
      },

      2: {
        iconClass: 'reading_mask',
        iconAlt: '',
        label: 'widget.menu.reading_mask.label',
        aria: 'widget.menu.reading_mask.aria',
      },
      3: {
        iconClass: 'guide',
        iconAlt: '',
        label: 'widget.menu.reading_guide.label',
        aria: 'widget.menu.reading_guide.aria',
      },
    },
    onActionTrigger(actionState) {
      const trigger: Record<string, string | number> = { feature: 's2' };
      if (actionState === 0 || !actionState) {
        trigger.actionState = 1;
        trigger.toRead = 'widget.menu.big_cursor.aria';
      } else if (actionState === 1) {
        trigger.actionState = 2;
        trigger.toRead = 'widget.menu.reading_mask.aria';
      } else if (actionState === 2) {
        trigger.actionState = 3;
        trigger.toRead = 'widget.menu.reading_guide.aria';
      } else {
        trigger.actionState = 0;
        trigger.toRead = 'widget.menu.cursor.aria_off_action';
      }

      return trigger;
    },
  },

  s3: {
    description: 'Contrast',
    modifyMenuLabel: 'Contrast',
    actionStates: {
      0: {
        iconClass: 'contrast_low',
        iconAlt: '',
        label: 'widget.menu.contrast.label.v0',
        aria: 'widget.menu.contrast.aria.v0',
      },
      1: {
        iconClass: 'contrast_invert',
        iconAlt: '',
        label: 'widget.menu.contrast.label.v1',
        aria: 'widget.menu.contrast.aria.v1',
      },
      2: {
        iconClass: 'contrast_dark',
        iconAlt: '',
        label: 'widget.menu.contrast.label.v2',
        aria: 'widget.menu.contrast.aria.v2',
      },
      3: {
        iconClass: 'contrast_low',
        iconAlt: '',
        label: 'widget.menu.contrast.label.v3',
        aria: 'widget.menu.contrast.aria.v3',
      },
    },
    onActionTrigger(actionState) {
      const trigger: Record<string, string | number> = { feature: 's3' };
      if (actionState === 0) {
        trigger.actionState = 1;
        trigger.toRead = 'widget.menu.contrast.aria.v1';
      } else if (actionState === 1) {
        trigger.actionState = 2;
        trigger.toRead = 'widget.menu.contrast.aria.v2';
      } else if (actionState === 2) {
        trigger.actionState = 3;
        trigger.toRead = 'widget.menu.contrast.aria.v3';
      } else {
        trigger.actionState = 0;
        trigger.toRead = 'widget.menu.contrast.aria_off_action';
      }

      return trigger;
    },
  },

  s4: {
    description: 'Bigger Text',
    modifyMenuLabel: 'Bigger Text',
    actionStates: {
      0: {
        iconClass: 'btext_1',
        iconWrapClass: 'bigger-text',
        iconAlt: 'widget.menu.bigger_text.alt.img',
        label: 'widget.menu.bigger_text.label',
        aria: 'widget.menu.bigger_text.aria.v0',
      },
      1: {
        iconClass: 'btext_2',
        iconWrapClass: 'bigger-text',
        iconAlt: 'widget.menu.bigger_text.alt.img',
        label: 'widget.menu.bigger_text.label',
        aria: 'widget.menu.bigger_text.aria.v1',
      },
      2: {
        iconClass: 'btext_3',
        iconWrapClass: 'bigger-text',
        iconAlt: 'widget.menu.bigger_text.alt.img',
        label: 'widget.menu.bigger_text.label',
        aria: 'widget.menu.bigger_text.aria.v2',
      },
      3: {
        iconClass: 'btext_4',
        iconWrapClass: 'bigger-text',
        iconAlt: 'widget.menu.bigger_text.alt.img',
        label: 'widget.menu.bigger_text.label',
        aria: 'widget.menu.bigger_text.aria.v3',
      },
      4: {
        iconClass: 'btext_5',
        iconWrapClass: 'bigger-text',
        iconAlt: 'widget.menu.bigger_text.alt.img',
        label: 'widget.menu.bigger_text.label',
        aria: 'widget.menu.bigger_text.aria.v4',
      },
    },
    onActionTrigger(actionState) {
      const trigger: Record<string, string | number> = { feature: 's4' };
      if (actionState === 0 || !actionState) {
        trigger.actionState = 1;
        trigger.toRead = 'widget.menu.bigger_text.aria.v1';
      } else if (actionState === 1) {
        trigger.actionState = 2;
        trigger.toRead = 'widget.menu.bigger_text.aria.v2';
      } else if (actionState === 2) {
        trigger.actionState = 3;
        trigger.toRead = 'widget.menu.bigger_text.aria.v3';
      } else if (actionState === 3) {
        trigger.actionState = 4;
        trigger.toRead = 'widget.menu.bigger_text.aria.v4';
      } else {
        trigger.actionState = 0;
        trigger.toRead = 'widget.menu.bigger_text.aria_off_action';
      }

      return trigger;
    },
  },

  s6: {
    description: 'Highlight links',
    modifyMenuLabel: 'Highlight Links',
    actionStates: {
      0: {
        iconClass: 'highlight-links',
        iconAlt: 'widget.menu.underline_links.alt',
        label: 'widget.menu.underline_links.label',
        aria: 'widget.menu.underline_links.aria',
      },
      1: {
        iconClass: 'highlight-links',
        iconAlt: 'widget.menu.underline_links.alt',
        label: 'widget.menu.underline_links.label',
        aria: 'widget.menu.underline_links.aria_on_action',
      },
    },
    onActionTrigger(actionState) {
      const trigger: Record<string, string | number> = { feature: 's6' };
      if (actionState === 0 || !actionState) {
        trigger.actionState = 1;
        trigger.toRead = 'widget.menu.underline_links.aria_on_action';
      } else {
        trigger.actionState = 0;
        trigger.toRead = 'widget.menu.underline_links.aria_off_action';
      }
      return trigger;
    },
  },

  s7: {
    description: 'Legible fonts',
    modifyMenuLabel: 'Dyslexia/Legible Fonts',
    actionStates: {
      0: {
        iconClass: 'dyslexia',
        iconAlt: 'widget.menu.dyslexia_friendly.alt',
        label: 'widget.menu.dyslexia_friendly.label',
        aria: 'widget.menu.dyslexia_friendly.aria',
      },
      1: {
        iconClass: 'dyslexia',
        iconAlt: 'widget.menu.dyslexia_friendly.alt',
        label: 'widget.menu.dyslexia_friendly.label',
        aria: 'widget.menu.dyslexia_friendly.aria_on_action',
      },
      2: {
        iconClass: 'legible-fonts',
        iconAlt: 'widget.menu.legible_fonts.alt',
        label: 'widget.menu.legible_fonts.label',
        aria: 'widget.menu.legible_fonts.aria',
      },
    },
    onActionTrigger(actionState) {
      const trigger: Record<string, string | number> = { feature: 's7' };
      if (actionState === 0 || !actionState) {
        trigger.actionState = 1;
        trigger.toRead = 'widget.menu.dyslexia_friendly.aria_on_action';
      } else if (actionState === 1) {
        trigger.actionState = 2;
        trigger.toRead = 'widget.menu.legible_fonts.aria_on_action';
      } else {
        trigger.actionState = 0;
        trigger.toRead = 'widget.menu.legible_fonts.aria_off_action';
      }
      return trigger;
    },
  },

  s8: {
    description: 'Reset All',
    modifyMenuLabel: 'Reset All',
    actionStates: {
      0: {
        iconClass: 'reset_lg',
        iconAlt: 'widget.menu.reset.label',
        label: 'widget.menu.reset.label',
        aria: 'widget.menu.reset.aria',
      },
    },
    onActionTrigger() {
      return {
        feature: 's8',
        actionState: 0,
        toRead: 'widget.menu.reset.aria_off_action',
      };
    },
  },

  s9: {
    description: 'Screen Reader',
    modifyMenuLabel: 'Screen Reader',
    actionStates: {
      0: {
        iconClass: 'read',
        iconAlt: '',
        label: 'widget.menu.responsive_voice.label.v0',
        aria: 'widget.menu.responsive_voice.aria.v0',
      },
      1: {
        iconClass: 'read',
        iconAlt: '',
        label: 'widget.menu.responsive_voice.label.v1',
        aria: 'widget.menu.responsive_voice.aria.v1',
      },
      2: {
        iconClass: 'read_fast',
        iconAlt: '',
        label: 'widget.menu.responsive_voice.label.v2',
        aria: 'widget.menu.responsive_voice.aria.v2',
      },
      3: {
        iconClass: 'read_slow',
        iconAlt: '',
        label: 'widget.menu.responsive_voice.label.v3',
        aria: 'widget.menu.responsive_voice.aria.v3',
      },
    },
    onActionTrigger(actionState) {
      const trigger: Record<string, string | number> = { feature: 's9' };
      if (actionState === 0 || !actionState) {
        trigger.actionState = 1;
        trigger.toRead = 'widget.menu.responsive_voice.aria.v1';
      } else if (actionState === 1) {
        trigger.actionState = 2;
        trigger.toRead = 'widget.menu.responsive_voice.aria.v2';
      } else if (actionState === 2) {
        trigger.actionState = 3;
        trigger.toRead = 'widget.menu.responsive_voice.aria.v3';
      } else {
        trigger.actionState = 0;
        trigger.toRead = 'widget.menu.responsive_voice.aria_off_action';
      }

      return trigger;
    },
  },

  s12: {
    description: 'Tooltips',
    modifyMenuLabel: 'Tooltips',
    actionStates: {
      0: {
        iconClass: 'tooltip',
        iconAlt: '',
        label: 'widget.menu.tooltips.label',
        aria: 'widget.menu.tooltips.aria',
      },
      1: {
        iconClass: 'tooltip',
        iconAlt: '',
        label: 'widget.menu.tooltips.label',
        aria: 'widget.menu.tooltips.aria_on_action',
      },
    },
    onActionTrigger(actionState) {
      const trigger: Record<string, string | number> = { feature: 's12' };
      if (actionState === 0 || !actionState) {
        trigger.actionState = 1;
        trigger.toRead = 'widget.menu.tooltips.aria_on_action';
      } else {
        trigger.actionState = 0;
        trigger.toRead = 'widget.menu.tooltips.aria_off_action';
      }
      return trigger;
    },
  },

  s11: {
    description: 'Page structure',
    modifyMenuLabel: 'Page Structure',
    actionStates: {
      0: {
        iconClass: 'page-structure',
        iconAlt: '',
        label: 'widget.menu.page_structure.label',
        aria: 'widget.menu.page_structure.aria',
      },
      1: {
        iconClass: 'page-structure',
        iconAlt: '',
        label: 'widget.menu.page_structure.label',
        aria: 'widget.menu.page_structure.aria_on_action',
      },
    },
    onActionTrigger(actionState) {
      const trigger: Record<string, string | number> = { feature: 's11' };
      if (actionState === 0 || !actionState) {
        trigger.actionState = 1;
        trigger.toRead = 'widget.menu.page_structure.aria_on_action';
      } else {
        trigger.actionState = 0;
        trigger.toRead = 'widget.menu.page_structure.aria_off_action';
      }
      return trigger;
    },
  },

  s13: {
    description: 'Pause Animations',
    modifyMenuLabel: 'Pause Animations',
    actionStates: {
      0: {
        iconClass: 'pause',
        iconAlt: '',
        label: 'widget.menu.stop_animations.label.v0',
        aria: 'widget.menu.stop_animations.aria',
      },
      1: {
        iconClass: 'play',
        iconAlt: '',
        label: 'widget.menu.stop_animations.label.v1',
        aria: 'widget.menu.stop_animations.aria_on_action',
      },
    },
    onActionTrigger(actionState) {
      const trigger: Record<string, string | number> = { feature: 's13' };
      if (actionState === 0 || !actionState) {
        trigger.actionState = 1;
        trigger.toRead = 'widget.menu.stop_animations.aria_on_action';
      } else {
        trigger.actionState = 0;
        trigger.toRead = 'widget.menu.stop_animations.aria_off_action';
      }
      return trigger;
    },
  },

  s14: {
    description: 'Text Spacing',
    modifyMenuLabel: 'Text Spacing',
    actionStates: {
      0: {
        iconClass: 'text_spacing_medium',
        iconAlt: 'widget.menu.spacing_text.alt',
        label: 'widget.menu.spacing_text.label.v0',
        aria: 'widget.menu.spacing_text.aria.v0',
      },
      1: {
        iconClass: 'text_spacing_small',
        iconAlt: 'widget.menu.spacing_text.alt',
        label: 'widget.menu.spacing_text.label.v1',
        aria: 'widget.menu.spacing_text.aria.v1',
      },
      2: {
        iconClass: 'text_spacing_medium',
        iconAlt: 'widget.menu.spacing_text.alt',
        label: 'widget.menu.spacing_text.label.v2',
        aria: 'widget.menu.spacing_text.aria.v2',
      },
      3: {
        iconClass: 'text_spacing_large',
        iconAlt: 'widget.menu.spacing_text.alt',
        label: 'widget.menu.spacing_text.label.v3',
        aria: 'widget.menu.spacing_text.aria.v3',
      },
    },
    onActionTrigger(actionState) {
      const trigger: Record<string, string | number> = { feature: 's14' };
      if (actionState === 0 || !actionState) {
        trigger.actionState = 1;
        trigger.toRead = 'widget.menu.spacing_text.aria.v1';
      } else if (actionState === 1) {
        trigger.actionState = 2;
        trigger.toRead = 'widget.menu.spacing_text.aria.v2';
      } else if (actionState === 2) {
        trigger.actionState = 3;
        trigger.toRead = 'widget.menu.spacing_text.aria.v3';
      } else {
        trigger.actionState = 0;
        trigger.toRead = 'widget.menu.spacing_text.aria_off_action';
      }
      return trigger;
    },
  },

  s17: {
    description: 'Line Height',
    modifyMenuLabel: 'Line Height',
    actionStates: {
      0: {
        iconClass: 'line-height-1-5x',
        iconAlt: 'widget.menu.line_height.alt',
        label: 'widget.menu.line_height.label.v0',
        aria: 'widget.menu.line_height.aria.v0',
      },
      1: {
        iconClass: 'line-height-2x',
        iconAlt: 'widget.menu.line_height.alt',
        label: 'widget.menu.line_height.label.v1',
        aria: 'widget.menu.line_height.aria.v1',
      },
      2: {
        iconClass: 'line-height-3x',
        iconAlt: 'widget.menu.line_height.alt',
        label: 'widget.menu.line_height.label.v2',
        aria: 'widget.menu.line_height.aria.v2',
      },
      3: {
        iconClass: 'line-height-4x',
        iconAlt: 'widget.menu.line_height.alt',
        label: 'widget.menu.line_height.label.v3',
        aria: 'widget.menu.line_height.aria.v3',
      },
    },
    onActionTrigger(actionState) {
      const trigger: Record<string, string | number> = { feature: 's17' };
      if (actionState === 0 || !actionState) {
        trigger.actionState = 1;
        trigger.toRead = 'widget.menu.line_height.aria.v1';
      } else if (actionState === 1) {
        trigger.actionState = 2;
        trigger.toRead = 'widget.menu.line_height.aria.v2';
      } else if (actionState === 2) {
        trigger.actionState = 3;
        trigger.toRead = 'widget.menu.line_height.aria.v3';
      } else {
        trigger.actionState = 0;
        trigger.toRead = 'widget.menu.line_height.aria_off_action';
      }
      return trigger;
    },
  },
  s18: {
    description: 'Smart Contrast',
    modifyMenuLabel: 'Smart Contrast',
    actionStates: {
      0: {
        iconClass: 'smart-contrast',
        iconAlt: '',
        label: 'widget.menu.smart_contrast.label',
        aria: 'widget.menu.smart_contrast.aria',
      },
      1: {
        iconClass: 'smart-contrast',
        iconAlt: '',
        label: 'widget.menu.smart_contrast.label',
        aria: 'widget.menu.smart_contrast.aria',
      },
    },
    onActionTrigger(actionState) {
      const trigger: Record<string, string | number> = { feature: 's18' };
      if (actionState === 0 || !actionState) {
        trigger.actionState = 1;
        trigger.toRead = 'widget.menu.contrast.aria.v4';
      } else {
        trigger.actionState = 0;
        trigger.toRead = 'widget.menu.smart_contrast.aria_off_action';
      }
      return trigger;
    },
  },
  s19: {
    description: 'Text Align',
    modifyMenuLabel: 'Text Align',
    actionStates: {
      0: {
        iconClass: 'align-left',
        iconAlt: 'widget.menu.text_align.alt',
        label: 'widget.menu.text_align.label.v0',
        aria: 'widget.menu.text_align.aria.v0',
      },
      1: {
        iconClass: 'align-left',
        iconAlt: 'widget.menu.text_align.alt',
        label: 'widget.menu.text_align.label.v1',
        aria: 'widget.menu.text_align.aria.v1',
      },
      2: {
        iconClass: 'align-right',
        iconAlt: 'widget.menu.text_align.alt',
        label: 'widget.menu.text_align.label.v2',
        aria: 'widget.menu.text_align.aria.v2',
      },
      3: {
        iconClass: 'align-center',
        iconAlt: 'widget.menu.text_align.alt',
        label: 'widget.menu.text_align.label.v3',
        aria: 'widget.menu.text_align.aria.v3',
      },
      4: {
        iconClass: 'justify',
        iconAlt: 'widget.menu.text_align.alt',
        label: 'widget.menu.text_align.label.v4',
        aria: 'widget.menu.text_align.aria.v4',
      },
    },
    onActionTrigger(actionState) {
      const trigger: Record<string, string | number> = { feature: 's19' };
      if (actionState === 0 || !actionState) {
        trigger.actionState = 1;
        trigger.toRead = 'widget.menu.text_align.aria.v1';
      } else if (actionState === 1) {
        trigger.actionState = 2;
        trigger.toRead = 'widget.menu.text_align.aria.v2';
      } else if (actionState === 2) {
        trigger.actionState = 3;
        trigger.toRead = 'widget.menu.text_align.aria.v3';
      } else if (actionState === 3) {
        trigger.actionState = 4;
        trigger.toRead = 'widget.menu.text_align.aria.v4';
      } else {
        trigger.actionState = 0;
        trigger.toRead = 'widget.menu.text_align.aria_off_action';
      }
      return trigger;
    },
  },
  s23: {
    description: 'Saturation',
    modifyMenuLabel: 'Saturation',
    actionStates: {
      0: {
        iconClass: 'saturation-1',
        iconAlt: 'widget.menu.saturation.alt',
        label: 'widget.menu.saturation.label.v0',
        aria: 'widget.menu.saturation.aria.v0',
      },
      1: {
        iconClass: 'saturation-2',
        iconAlt: 'widget.menu.saturation.alt',
        label: 'widget.menu.saturation.label.v1',
        aria: 'widget.menu.saturation.aria.v1',
      },
      2: {
        iconClass: 'saturation-3',
        iconAlt: 'widget.menu.saturation.alt',
        label: 'widget.menu.saturation.label.v2',
        aria: 'widget.menu.saturation.aria.v2',
      },
      3: {
        iconClass: 'saturation-4',
        iconAlt: 'widget.menu.saturation.alt',
        label: 'widget.menu.saturation.label.v3',
        aria: 'widget.menu.saturation.aria.v3',
      },
    },
    onActionTrigger(actionState) {
      const trigger: Record<string, string | number> = { feature: 's23' };
      if (actionState === 0 || !actionState) {
        trigger.actionState = 1;
        trigger.toRead = 'widget.menu.saturation.aria.v1';
      } else if (actionState === 1) {
        trigger.actionState = 2;
        trigger.toRead = 'widget.menu.saturation.aria.v2';
      } else if (actionState === 2) {
        trigger.actionState = 3;
        trigger.toRead = 'widget.menu.saturation.aria.v3';
      } else {
        trigger.actionState = 0;
        trigger.toRead = 'widget.menu.saturation.aria_off_action';
      }
      return trigger;
    },
  },
};
